import { cn } from '@/utilities/cn';
import React from 'react';

import { serializeLexical } from './serialize';
import { WithTheme } from "@/types/WithTheme";

type Props = WithTheme & {
  className?: string
  content: Record<string, any>
  enableGutter?: boolean
  enableProse?: boolean
  disablePadding?: boolean | null
  maxWidth?: number | null
}

const RichText: React.FC<Props> = ( props ) => {
  const {
    className,
    content,
    enableGutter = true,
    enableProse = true,
    disablePadding = false,
    theme,
    maxWidth
  } = props;

  if ( !content ) return null;

  return (
    <div
      className={ cn(
        {
          'container ': enableGutter,
          'max-w-none': !enableGutter,
          'mx-auto prose dark:prose-invert ': enableProse,
          '[&_*]:my-text-reset [&_*:first-child]:mt-0 [&_*:last-child]:mb-0': !disablePadding,
        },
        'whitespace-break-spaces [&_li:has(ul)]:list-none',
        className,
      ) }
      style={ { ...( maxWidth ? { maxWidth: `${maxWidth}px` } : {} ) } }
    >
      { content &&
        !Array.isArray( content ) &&
        typeof content === 'object' &&
        'root' in content &&
        serializeLexical( { nodes: content?.root?.children, theme } ) }
    </div>
  );
};

export default RichText;
